import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FloatingPortal, FloatingFocusManager, useMergeRefs } from '@floating-ui/react';
import React from 'react';
import { useDropdownContext } from '../../contexts/Dropdown';
import { StyledDropdownMenu } from './Dropdown.styles';
import './FloatingPortalStyles.css';
const DropdownMenu = React.forwardRef(({ children, style, closeOnClick, ...props }, forwardedRef) => {
    const { x, y, refs, context, strategy, isOpen, setIsOpen, getFloatingProps, getItemProps, listItemsRef, } = useDropdownContext();
    const ref = useMergeRefs([refs.setFloating, forwardedRef]);
    return isOpen ? (_jsx(FloatingPortal, { id: 'floating-portal', children: _jsx(FloatingFocusManager, { context: context, modal: false, initialFocus: -1, children: _jsx(StyledDropdownMenu, { ref: ref, style: {
                    position: strategy,
                    top: y ?? 0,
                    left: x ?? 0,
                    ...style,
                }, ...getFloatingProps(props), children: React.Children.map(children, (child, index) => React.isValidElement(child) &&
                    React.cloneElement(child, {
                        toggleOpenMenuState: setIsOpen,
                        ...getItemProps({
                            ref(node) {
                                if (node?.role === 'menuitem')
                                    listItemsRef.current[index] = node;
                            },
                            onClick(event) {
                                child.props.onClick?.(event);
                                if (closeOnClick)
                                    setIsOpen(false);
                            },
                        }),
                    })) }) }) })) : (_jsx(_Fragment, {}));
});
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = {
    closeOnClick: true,
};
export default DropdownMenu;
